/* eslint-disable import/prefer-default-export */
export const LABELS = {
  TITLE: ' ownership details',
  SUBTITLE: 'Basic ownership details for ',
};
